// Interview API service — the capabilities-aware profile interview.
//
// Uses apiFetch (cookie + mock-user + view-as aware) rather than the inline
// fetch+mockAuthHeaders sprinkled across the older enhancement pages.
import { apiFetch } from '../utils/apiFetch';
import { API_URL } from '../config';

const BASE = `${API_URL}/api/interview`;

const jsonHeaders = { 'Content-Type': 'application/json' };

async function asJson(res) {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Interview API ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

// Begin or resume the interview. entryMode: 'backfill' (default) | 'now'.
export async function startInterview(entryMode) {
  const res = await apiFetch(`${BASE}/start`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ entry_mode: entryMode || null }),
  });
  return asJson(res);
}

// Send one user message; history is [{role, content}, ...].
export async function sendTurn(message, history = []) {
  const res = await apiFetch(`${BASE}/turn`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ message, history }),
  });
  return asJson(res);
}

// Current session state (phase, orientation, frontier, next_hook) — for the dashboard card.
export async function getSession() {
  const res = await apiFetch(`${BASE}/session`);
  return asJson(res);
}

// Mark a frontier hook done/skipped (after the user drills or dismisses it).
export async function resolveHook(hookId, status = 'done') {
  const res = await apiFetch(`${BASE}/hooks/${encodeURIComponent(hookId)}/resolve`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ status }),
  });
  return asJson(res);
}

// Delete the session (draft stubs are left intact). Dev/testing aid.
export async function resetInterview() {
  const res = await apiFetch(`${BASE}/reset`, { method: 'POST' });
  return asJson(res);
}
